import uuid from 'uuid';
import { SET_ALERT, REMOVE_ALERT } from '../types';

// Dozens of places across the app catch a failed fetch and call
// setAlert(error.message, ...) directly. When the backend hiccups and
// returns its own HTML page instead of JSON (a route not deployed yet,
// a brief redeploy window, a network blip), `.json()` throws a raw
// browser SyntaxError like `Unexpected token '<', "<!DOCTYPE "... is not
// valid JSON` - and that exact technical text was getting shown to
// customers and admins as if it were a real message. Since this one
// action is the single choke point every one of those calls goes
// through, catching it here fixes all of them at once instead of
// rewriting ~50 call sites individually.
const looksLikeRawError = msg =>
  typeof msg === 'string' &&
  (msg.includes('Unexpected token') ||
    msg.includes('is not valid JSON') ||
    msg.includes('JSON.parse') ||
    msg.trim().startsWith('<') ||
    msg.includes('Failed to fetch') ||
    msg.includes('NetworkError'));

export const setAlert = (msg, alertType, timeout = 5000) => dispatch => {
  const id = uuid.v4();
  const safeMsg = looksLikeRawError(msg)
    ? 'Something went wrong loading this page. Please refresh and try again.'
    : msg;
  dispatch({
    type: SET_ALERT,
    payload: { msg: safeMsg, alertType, id }
  });

  setTimeout(() => dispatch({ type: REMOVE_ALERT, payload: id }), timeout);
};
